export default __webpack_public_path__ + "scene5_3_bg7dbc52.png";